/** Feedback locations from the control-group registry (nested monickers joined with " - "). */

import { controlGroupLabels } from '@frontend/pages/dashboard/controlGroupRegistry';

export const BUG_LOCATIONS = controlGroupLabels({ includeFeatureOnly: false });

export const FEATURE_LOCATIONS = controlGroupLabels({ includeFeatureOnly: true });

export const FEATURE_STORY_PLACEHOLDER = `As a [role], I want [capability], so that [benefit].

Given [context]
When I [action]
Then [outcome]`;
